import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import store from '../../store'
import { qs, qsa } from '../../utils'
import DefaultRenderer from './Default'

Swiper.use([Navigation, Pagination, EffectFade, Autoplay])
class HomeRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  initRender() {
    store.resizeFn = null
    this.setHeaderStyle('white')
    this.onPageChange()
    this.slideHome()
    var objThis = this
    qsa('.asac .term-type-hide > button').forEach((element) => {
      element.addEventListener('click', function (ev) {
        ev.stopPropagation()
        $('.terms-d-container').slideUp(650)
        $('#' + this.dataset.termtrigger).slideDown(650, () => {
          objThis.scroll.update()
        })

        qsa('.asac .term-type-hide button').forEach((element) => {
          element.classList.remove('active')
        })
        element.classList.add('active')
      })
    })

    $('.close').on('click', function () {
      $('#home-page-banner').slideUp()
    })
  }

  onEnter() {
    super.onEnter()

    !window.location.href.includes('privacyandterms') &&
      !window.location.href.includes('evolve-bank-and-trust') &&
      !window.location.href.includes('lead-bank') &&
      !window.location.href.includes('fti') &&
      !window.location.href.includes('asac') &&
      !window.location.href.includes('electronic-communications-consent') &&
      qs('#header').classList.add('no-bg')
    if (qs('.phone-desktop-slide')) {
      this.phoneSlide && this.phoneSlide.destroy()
      setTimeout(() => {
        this.setPhone()
      }, 1000)
    }
  }

  onLeave() {
    super.onLeave()
    qs('#header').classList.remove('no-bg')
  }

  onEnterCompleted() {
    super.onEnterCompleted()
    this.initRender()
  }

  onLeaveCompleted() {
    super.onLeaveCompleted()
  }

  setPhone() {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

    let autoplayObj = {
      autoplay: {
        delay: 5000,
        waitForTransition: true,
        disableOnInteraction: false,
      },
    }
    if (!mediaQuery || mediaQuery.matches) {
      autoplayObj.autoplay = false
    }
    this.phoneSlide = new Swiper(qs('.phone-desktop-slide'), {
      slidesPerView: 1,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      spaceBetween: 10,
      speed: 1000,
      ...autoplayObj,
    })

    const options = qsa('.h-woption')
    options.forEach((o) => {
      o.addEventListener('click', () => {
        this.phoneSlide.slideTo(parseInt(o.dataset.opt.replace('opt-', '')))
        this.phoneSlide.update()
      })
    })

    this.phoneSlide.on('activeIndexChange', function () {
      options.forEach(($h) => {
        $h.classList.remove('active')
      })
      qs('.h-woption[data-opt=opt-' + this.activeIndex + ']') &&
        qs('.h-woption[data-opt=opt-' + this.activeIndex + ']').classList.add('active')
    })
  }

  slideHome() {
    // if (store.bounds.ww > 900)
    setTimeout(() => {
      const $slideHomeContent = qsa('.h-s-i-back')
      var maxHeight = 0
      $slideHomeContent.forEach(($elem) => {
        if ($elem.offsetHeight > maxHeight) maxHeight = $elem.offsetHeight
      })
      $slideHomeContent.forEach(($elem) => {
        $elem.style.height = maxHeight + 'px'
      })
    }, 1000)
    let autoplayObj = {
      autoplay: {
        delay: 4000,
        waitForTransition: true,
        disableOnInteraction: false,
      },
    }
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

    if (!mediaQuery || mediaQuery.matches) {
      autoplayObj.autoplay = false
    }

    const homeSlideLinks = new Swiper('#hero-links-slide', {
      slidesPerView: 2,
      // spaceBetween: 100,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      loop: true,
      speed: 1000,
      ...autoplayObj,
    })
    autoplayObj = {
      autoplay: {
        delay: 5000,
        waitForTransition: true,
        disableOnInteraction: false,
      },
    }
    if (!mediaQuery || mediaQuery.matches) {
      autoplayObj.autoplay = false
    }

    const heroSlide = new Swiper('.hero-slide-text', {
      slidesPerView: 'auto',
      spaceBetween: 50,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      autoHeight: true,
      loop: true,
      speed: 1000,
      navigation: {
        nextEl: '.h-s-next',
        prevEl: '.h-s-prev',
      },
    })
  }
}

export default HomeRenderer
